import BulkActionsController from "controllers/components/bulk_actions_controller"
export default class extends BulkActionsController {
  static targets = ["removeForm"]

  handleToggleSingle(e) {
    super.handleToggleSingle(e)

    this.appendToForm($(this.removeFormTarget))
  }

  handleToggleAll(e) {
    super.handleToggleAll(e)

    this.appendToForm($(this.removeFormTarget))
  }

  appendToForm(form) {
    const settingIds = this.getSelected()
    form.find(".exclusion-input").remove()
    for (let id of settingIds) {
      const input = $("<input type='hidden'>")
        .attr({
          name: "antivirus_exclusions_settings_form[setting_ids][]",
          value: id,
        })
        .addClass("exclusion-input")
      form.append(input)
    }
  }

  getSelected() {
    const selected = $(this.element).find(".bulk-select:checked")
    return selected.map((i, e) => {
      return $(e).data("setting-id")
    })
  }
}
